<template>
    <div>
        <!-- معلومات الحساب -->
        <b-row v-if="data.est_ngo && data.est_ngo.estAccount">
            <b-col cols="12">
              <h5 for="">معلومات الحساب</h5>
              <hr />
            </b-col>
            <b-col md="4" cols="12">
                <info-card
                label="الاسم الأول"
                :value="data.est_ngo.estAccount.first_name"
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card label="اسم الأب"
                :value="data.est_ngo.estAccount.father_name"
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card label="الكنية"
                :value="data.est_ngo.estAccount.last_name"
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card
                label="اسم المستخدم"
                :value="data.est_ngo.estAccount.username"
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card
                label="رقم الهاتف"
                :value="data.est_ngo.estAccount.phone_number"
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card label="الرقم الوطني" 
                :value="data.est_ngo.estAccount.id_number"
                />
            </b-col>     
            <b-col md="4" cols="12">
                <info-card 
                label="البريد الالكتروني"
                :value="data.est_ngo.estAccount.email"
                />
            </b-col>    
        </b-row>
        <!-- معلومات المنظمة -->
        <b-row v-if="data.est_ngo">
            <b-col cols="12">
              <h5 for="">معلومات المنظمة</h5>
              <hr />
            </b-col>
            <b-col md="4" cols="12">
                <info-card
                label="اسم المنظمة قيد الـتأسيس"
                :value="data.est_ngo.ngo_name"
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card label="الاسم البديل الأول"
                :value="data.est_ngo.fst_alt_ngo_name"
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card label="الاسم البديل الثاني"
                :value="data.est_ngo.sec_alt_ngo_name"
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card 
                label="الشكل القانوني"
                :value="$t(data.est_ngo.legal_form_type)"
                />
            </b-col>  
            <b-col md="4" cols="12">
                <info-card 
                label="التصنيفات"
                :value="getLabelToShow(data.est_ngo.classifications)"
                />
                
            </b-col>   
            <b-col md="4" cols="12">
                <info-card 
                label="يتناول نشاطها المحافظات"
                :value="getLabelToShow(data.est_ngo.governorates)"
                />
            </b-col> 
            <b-col md="12" cols="12">
                <info-card 
                label="الأهداف"
                :value="data.est_ngo.objectives"
                />
            </b-col>  
        </b-row>
        <!-- معلومات المقر -->
        <b-row v-if="data.est_ngo">
            <b-col cols="12">
              <h5 for="">معلومات المقر</h5>
              <hr />
            </b-col>
            <b-col md="4" cols="12">
                <info-card
                label="اسم المقر"
                :value="data.est_ngo.hq.name"
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card label="محافظ المقر"
                :value="data.est_ngo.hq.governorate.name_ar"
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card label="المنقطة/الحي"
                :value="data.est_ngo.hq.subDistrict.name_ar"
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card
                label="عنوان المقر"
                :value="data.est_ngo.hq.address"
                />
            </b-col>
        </b-row>
        <!-- معلومات العقار -->
        <b-row v-if="data.est_ngo">
            <b-col cols="12">
              <h5 for="">معلومات العقار</h5>
              <hr />
            </b-col>
            <b-col md="4" cols="12">
                <info-card
                label="رقم العقار"
                :value="data.est_ngo.realEstate.number"
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card label="نوع العقار"
                :value="data.est_ngo.realEstate.estateType.name_ar"
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card label="المنطقة الإدارية"
                :value="data.est_ngo.realEstate.region"
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card
                label="الحصة السهمية"
                :value="data.est_ngo.realEstate.equity_share"
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card
                label="صيغة التملك"
                :value="data.est_ngo.realEstate.possessiveForm.name_ar"
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card
                label="موضوع الخدمة"
                :value="data.est_ngo.realEstate.is_operating == 1 ? 'نعم' : 'لا'"
                />
            </b-col>
            <b-col cols="4">
                <div class="info-card px-2 py-1 my-1">
                <div class="d-flex align-items-center justify-content-between">
                    <div>
                      وثيقة العقار
                    </div>
                    <div>
                    <b-button
                        variant="flat-info"
                        v-b-toggle.doc-view
                        class="btn-icon mx-25"
                        v-b-tooltip.hover.v-info.bottom
                        title="عرض المستند المرفوع"
                        :to="{ name: 'file-view', query: { ep:data.est_ngo.realEstate.estate_document } }"
                    >
                        <feather-icon icon="EyeIcon"
                    /></b-button>
                    </div>
                </div>
                <div>
                    <hr />
                </div>
                </div>
            </b-col>
        </b-row>
        <!-- وثائق التأسيس -->
        <b-row v-if="data.est_ngo">
            <b-col cols="12">
              <h5 for="">وثائق التأسيس</h5>
              <hr />
            </b-col>
            <b-col cols="4" v-for="doc in data.est_ngo.estDocs" :key="doc.id">
                <div class="info-card px-2 py-1 my-1">
                <div class="d-flex align-items-center justify-content-between">
                    <div>
                      {{doc.attachment.filename}}
                    </div>
                    <div>
                    <b-button
                        variant="flat-info"
                        v-b-toggle.doc-view
                        class="btn-icon mx-25"
                        v-b-tooltip.hover.v-info.bottom
                        title="عرض المستند المرفوع"
                        :to="{ name: 'file-view', query: { ep:doc.source } }"
                    >
                        <feather-icon icon="EyeIcon"
                    /></b-button>
                    </div>
                </div>
                <div>
                    <hr />
                </div>
                </div>
            </b-col>
        </b-row>
        <!-- معلومات الأعضاء المؤسسين و ملفاتهم  -->
        <b-row v-if="data.est_ngo">
            <b-col cols="12">
              <h5 for="">معلومات الأعضاء المؤسسين و ملفاتهم </h5>
              <hr />
            </b-col>
            
            <b-col md="12" cols="12">
                <div>
                    <b-tabs content-class="mt-3">
                        <b-tab v-for="(member , i) in data.est_ngo.estMembers" :key="i" :title="`العضو ${ getArrangement(i+1) }`">
                            <b-row>
                                <b-col md="4" cols="12">
                                    <info-card
                                    label="الاسم الثلاثي"
                                    :value="member.full_name"
                                    />
                                </b-col>
                                <b-col md="4" cols="12">
                                    <info-card
                                    label="الرقم الوطني"
                                    :value="member.id_number"
                                    />
                                </b-col>
                                <b-col md="4" cols="12">
                                    <info-card
                                    label="عنوان السكن"
                                    :value="member.address"
                                    />
                                </b-col>
                                <b-col md="4" cols="12">
                                    <info-card
                                    label="المؤهل العلمي"
                                    :value="member.qualification ? member.qualification.title : ''"
                                    />
                                </b-col>
                                <b-col md="4" cols="12">
                                    <info-card
                                    label="العمل"
                                    :value="member.job ? member.job.name :'' "
                                    />
                                </b-col>
                                <b-col md="4" cols="12">
                                    <info-card
                                    label="رقم الهاتف"
                                    :value="member.phone_number"
                                    />
                                </b-col>
                                <b-col cols="4">
                                    <div class="info-card px-2 py-1 my-1">
                                    <div class="d-flex align-items-center justify-content-between">
                                        <div>
                                        نشرة الإستعلام
                                        </div>
                                        <div>
                                        <b-button
                                        
                                            variant="flat-info"
                                            v-b-toggle.doc-view
                                            class="btn-icon mx-25"
                                            v-b-tooltip.hover.v-info.bottom
                                            title="عرض المستند المرفوع"
                                            :to="{ name: 'file-view', query: { ep:member.inquiry_bulletin_file } }"
                                        >
                                            <feather-icon icon="EyeIcon"
                                        /></b-button>
                                        </div>
                                    </div>
                                    <div>
                                        <hr />
                                    </div>
                                    </div>
                                </b-col> 
                            
                            </b-row>
                        </b-tab>
                    </b-tabs>
                </div>
            </b-col> 
        </b-row>
    </div>
  </template>
  
  <script>
  import { BCard , BImg , BCol , BRow , VBToggle , VBTooltip , BButton , BTabs , BTab , BFormGroup , BFormInput } from "bootstrap-vue";
  import InfoCard from "@/components/InfoCard.vue";
import { arrangement } from "@/utils/utils";
  export default {
    components: {
        BCard, BImg , BCol , InfoCard , BRow , BButton , BTabs , BTab , BFormGroup , BFormInput
    },
    props: {
        data : Object ,
    },
    
    directives: {
        "b-toggle": VBToggle,
        "b-tooltip": VBTooltip,
    },
    methods: {
    getArrangement(num){
      return arrangement(num)
    },
    getLabelToShow(value){
        return value.map(item => item.name_ar).join(', ');
    }
  },
  };
  </script>